import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Swal from "sweetalert2";
import Loading from "../../components/Common/Loading";

function CommonSettings(props) {
  const [isEmpty, setIsEmpty] = useState(false);
  const [content, setContent] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();
  const allFields = watch();
  const user = useSelector((state) => state.User);

  useEffect(() => {
    if (user?.user?.role?.title !== "Admin") {
      props.history.push("/dashboard");
    }
  }, []);

  // console.log("user", user);

  // get faqs
  const getPrivacy = () => {
    setIsLoading(true);
    apiReq(url.GET_COMMON, {}, "get", null)
      .then((res) => {
        if (res.success && res.data !== null) {
          setValue("navbar_cta_title", res.data.navbar_cta_title);
          setValue("navbar_cta_link", res.data.navbar_cta_link);
          setValue("cta_section_heading", res.data.cta_section_heading);
          setValue("cta_section_btn_title", res.data.cta_section_btn_title);
          setValue("cta_section_btn_link", res.data.cta_section_btn_link);
          setIsEmpty(false);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          setIsEmpty(true);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  useEffect(() => {
    getPrivacy();
  }, []);

  console.log("isEmpty", isEmpty);

  // Todo: Create privacy page first time
  const createPrivacy = (data) => {
    if (isEmpty) {
      setIsLoading(true);
      apiReq(
        url.CREATE_COMMON,
        {
          navbar_cta_title: data.navbar_cta_title,
          navbar_cta_link: data.navbar_cta_link,
          cta_section_heading: data.cta_section_heading,
          cta_section_btn_title: data.cta_section_btn_title,
          cta_section_btn_link: data.cta_section_btn_link,
        },
        "post",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          setIsEmpty(false);
          setIsLoading(false);
          Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          // console.log("res>>>", res);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    } else {
      setIsLoading(true);
      apiReq(
        url.UPDATE_COMMON,
        {
          navbar_cta_title: data.navbar_cta_title,
          navbar_cta_link: data.navbar_cta_link,
          cta_section_heading: data.cta_section_heading,
          cta_section_btn_title: data.cta_section_btn_title,
          cta_section_btn_link: data.cta_section_btn_link,
        },
        "put",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          setIsEmpty(false);
          setIsLoading(false);
          Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          // console.log("res>>>", res);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading && <Loading />}
        <Container fluid>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Common Settings</h5>
              <hr />
              <form onSubmit={handleSubmit(createPrivacy)}>
                <div className="mt-4">
                  <h5>Menu Bar CTA</h5>
                  <hr />
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label>Menu Bar CTA: Title</label>
                        <input
                          type="text"
                          className="form-control"
                          {...register("navbar_cta_title", { required: true })}
                          placeholder="Enter title"
                        />
                        {errors.navbar_cta_title && (
                          <span className="text-danger">
                            Menu Bar CTA Title is required
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label>Menu Bar CTA: Link</label>
                        <input
                          type="text"
                          className="form-control"
                          {...register("navbar_cta_link", { required: true })}
                          placeholder="Enter link"
                        />
                        {errors.navbar_cta_link && (
                          <span className="text-danger">
                            Menu Bar CTA Link is required
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-5">
                  <h5>Comom CTA Section</h5>
                  <hr />
                  <div className="mb-3">
                    <label>Section Heading</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("cta_section_heading", { required: true })}
                      placeholder="Enter heading"
                    />
                    {errors.cta_section_heading && (
                      <span className="text-danger">
                        Section heading is required
                      </span>
                    )}
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label>Section CTA Title</label>
                        <input
                          type="text"
                          className="form-control"
                          {...register("cta_section_btn_title", {
                            required: true,
                          })}
                          placeholder="Enter title"
                        />
                        {errors.cta_section_btn_title && (
                          <span className="text-danger">Title is required</span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label>Section CTA Link</label>
                        <input
                          type="text"
                          className="form-control"
                          {...register("cta_section_btn_link", {
                            required: true,
                          })}
                          placeholder="Enter link"
                        />
                        {errors.cta_section_btn_link && (
                          <span className="text-danger">Link is required</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <hr />
                <div>
                  <button className="btn btn-primary" type="submit">
                    Save changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default CommonSettings;
